import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import * as api from "shared/api/methods";

import * as types from "./types";

import { UserStatus } from "constants/enums";

export const getPosts = createAsyncThunk<any, any>(
  types.GET_POSTS,
  async ({ userId, queryParams }: any, { getState }) => {
    const state: any = getState();

    if (!userId || state.auth.user.status !== UserStatus.ACTIVE) {
      const response = await api.getDefaultPosts({ queryParams });

      return { ...response, queryParams };
    }

    const response = await api.getPosts({ userId, queryParams });

    return { ...response, queryParams };
  }
);

export const clearPosts = createAction<any>(types.CLEAR_POSTS);

export const getPost = createAsyncThunk<any, any>(
  types.GET_POST,
  async ({ userId, slug }: any, { getState }) => {
    const state: any = getState();

    if (!userId || state.auth.user.status !== UserStatus.ACTIVE) {
      const response = await api.getDefaultPost({ slug });

      return response;
    }

    try {
      const response = await api.getPost({ userId, slug });

      return response;
    } catch (error) {
      console.warn(error);

      return null;
    }
  }
);

export const updatePostToFavorites = createAsyncThunk<any, any>(
  types.UPDATE_POST_TO_FAVORITES,
  async ({ userId, postSlug, data }: any, { getState }) => {
    const state: any = getState();

    if (!userId || state.auth.user.status !== UserStatus.ACTIVE) {
      return null;
    }

    const response = await api.updatePost({ userId, postSlug, data });
    return response;
  }
);

export const updatePost = createAction<any>(types.UPDATE_POST);
